import { render, staticRenderFns } from "./livesub.vue?vue&type=template&id=01240d05"
import script from "./livesub.vue?vue&type=script&lang=js"
export * from "./livesub.vue?vue&type=script&lang=js"
import style0 from "./livesub.vue?vue&type=style&index=0&id=01240d05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports